import Vue from 'vue';

// 创建全局事件总线
export const EventBus = new Vue();

export default EventBus;